export const KNOWLEDGE_BASE_URL = {
  MEDIA_TYPES: 'https://knowledge-base.yieldbird.com/yieldbird-platform/media-types',
  NATIVE_CONFIGURATION: 'https://docs.prebid.org/dev-docs/show-native-ads.html#how-native-ads-work',
  VIDEO_CONFIGURATION:
    'https://docs.prebid.org/dev-docs/adunit-reference.html#adunitmediatypesvideo',
} as const

export const NEW_VIEWPORT_ID_FIELD = 'mediaTypes.newViewportId'
